import React from 'react';
import SidePanelLayout from "layouts/SidePanelLayout";
import WireTemplatesFilter from "./WireTemplatesFilter";
import WireTemplatesPanel from "./WireTemplatesPanel";

export default function WireTemplates() {

    return(<>
        <SidePanelLayout
            sideComponent={WireTemplatesFilter}
            mainComponent={WireTemplatesPanel}>
        </SidePanelLayout>
    </>);

}